// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16-C4","content":"styles_content__12P-l"};